import React from "react";
import styled from "styled-components";
import { SearchEngineOptimisation } from "../components/seo";
import { graphql } from "gatsby";
import { media } from "../components/media-queries";
import { Layout } from "../components/layout";
import { Hero } from "../components/hero";
import { Card } from "../components/card";
import { ShareThis } from "../components/share-this";
import { TweetBar } from "../components/tweet-bar";
import HeroImage from "../images/hero/luke_carrying_chimp-rs.jpg";

export const query = graphql`
  query ($id: String!) {
    markdownRemark(id: { eq: $id }) {
      frontmatter {
        title
        youtubeVideoId
      }
      html
    }
  }
`;

const FlexContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 30px 0 0 0;
  ${media.lg} {
    flex-direction: row;
  }
`;

const ContentContainer = styled.div`
  width: 100%;
  img {
    width: 100%;
  }
  ${media.lg} {
    border-right: 1px solid ${(props) => props.theme.colours.background};
    margin: 0 30px 0 0;
    padding: 0 30px 0 0;
    width: 66.66%;
  }
`;

const RightCol = styled.div`
  width: 100%;
  h3 {
    margin: 0 0 20px 0;
  }
  ${media.lg} {
    width: 33.33%;
  }
`;

const Template = ({ data }) => (
  <Layout>
    <SearchEngineOptimisation title={data.markdownRemark.frontmatter.title} />
    <Hero images={[HeroImage]} />
    <Card title={data.markdownRemark.frontmatter.title}>
      <div
        style={{ paddingTop: "56.25%", position: "relative", width: "100%" }}
      >
        <iframe
          title="Show-reel Video"
          style={{
            position: "absolute",
            top: "0",
            left: "0",
            width: "100%",
            height: "100%",
          }}
          src={`https://www.youtube.com/embed/${data.markdownRemark.frontmatter.youtubeVideoId}`}
          frameborder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
      </div>
      <FlexContainer>
        {data.markdownRemark.html && (
          <ContentContainer
            dangerouslySetInnerHTML={{
              __html: data.markdownRemark.html,
            }}
          />
        )}
        <RightCol>
          <ShareThis />
          <TweetBar />
        </RightCol>
      </FlexContainer>
    </Card>
  </Layout>
);

export default Template;
